import { render, staticRenderFns } from "./AgentsManagement.vue?vue&type=template&id=40dc2416&scoped=true&"
import script from "./agents-management.ts?vue&type=script&lang=ts&"
export * from "./agents-management.ts?vue&type=script&lang=ts&"
import style0 from "./AgentsManagement.vue?vue&type=style&index=0&id=40dc2416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc2416",
  null
  
)

export default component.exports